

// import React from 'react'
export default "Labor Warranty: We don't like coming back. It means we did not do our job to perfection. In the unlikely event that we missed a step on our labor, we will gladly return to make things right, at no cost to you. Please see our contact info below to submit a warranty claim."